import React from 'react';
import pt from 'prop-types';
import HeroTeaser, {
  proptypes as heroTeaserProptypes,
} from './components/heroTeaser';
import Link from '/src/components/ui/link';
import { combine } from '/src/helpers/styles';
import Image, { imageProptypes } from '../../ui/image';
import * as styles from './hero.module.scss';
import { linkProptypes } from '../../ui/link';
import Video from '../../ui/video';
import { SwiperSlide } from 'swiper/react';
import Carousel from '../../ui/carousel';
import Container from '../../../modules/container';

const CMSHero = ({
  background,
  backgroundImageLink,
  heroTeaser,
  disableGatsbyImage,
  items,
  carouselTeaser,
}) => {
  const renderImage = (background, heroTeaser) => (
    <Image
      disableGatsbyImage={disableGatsbyImage}
      image={background?.image}
      className={combine(
        styles.backgroundImage,
        heroTeaser &&
          (heroTeaser.isEditorial ||
            (heroTeaser.bigHeadline && heroTeaser.bigHeadline.bigHeadline) ||
            !heroTeaser) &&
          styles.fullHeightSm
      )}
    />
  );
  const renderVideo = () => (
    <Video
      playsInline
      video={background}
      autoplay
      controls={false}
      loop
      muted
      className={styles.backgroundVideo}
    />
  );

  const renderContent = (background, backgroundImageLink, heroTeaser) => {
    return (
      <>
        {backgroundImageLink ? (
          <Link
            link={backgroundImageLink}
            className={combine(
              styles.heroImageLink,
              background?.internal?.type === 'ContentfulVideo' &&
                styles.videoContainer
            )}
          >
            {background.image
              ? renderImage(background, heroTeaser)
              : renderVideo()}
          </Link>
        ) : (
          <div
            className={combine(
              styles.heroImageLink,
              background?.internal?.type === 'ContentfulVideo' &&
                styles.videoContainer
            )}
          >
            {background.image
              ? renderImage(background, heroTeaser)
              : renderVideo()}
          </div>
        )}
        {heroTeaser && (
          <Container className={styles.teaserContainer}>
            <HeroTeaser
              headline={heroTeaser?.headline}
              text={heroTeaser?.text}
              cta={heroTeaser?.cta}
              ctas={heroTeaser?.ctas}
              position={heroTeaser?.position}
              isRed={heroTeaser?.isRed}
              isEditorial={heroTeaser?.isEditorial}
              bigHeadline={
                heroTeaser.bigHeadline?.bigHeadline || heroTeaser.bigHeadline
              }
            />
          </Container>
        )}
      </>
    );
  };

  return items?.length > 0 ? (
    <div className={styles.hero}>
      <Carousel>
        {items.map(({ background, backgroundImageLink }, idx) => {
          return (
            <SwiperSlide key={`slide-${idx}`}>
              {renderContent(background, backgroundImageLink)}
            </SwiperSlide>
          );
        })}
      </Carousel>
      {carouselTeaser && (
        <Container className={styles.teaserContainer}>
          <HeroTeaser
            headline={carouselTeaser?.headline}
            text={carouselTeaser?.text}
            cta={carouselTeaser?.cta}
            ctas={carouselTeaser?.ctas}
            position={carouselTeaser?.position}
            isRed={carouselTeaser?.isRed}
            isEditorial={carouselTeaser?.isEditorial}
            bigHeadline={
              carouselTeaser.bigHeadline?.bigHeadline ||
              carouselTeaser.bigHeadline
            }
          />
        </Container>
      )}
    </div>
  ) : (
    <div className={styles.hero}>
      {renderContent(background, backgroundImageLink, heroTeaser)}
    </div>
  );
};

CMSHero.propTypes = {
  background: pt.shape(imageProptypes).isRequired,
  backgroundImageLink: pt.shape(linkProptypes),
  heroTeaser: pt.shape(heroTeaserProptypes),
  carouselTeaser: pt.shape(heroTeaserProptypes),
  disableGatsbyImage: pt.bool,
  items: pt.array,
};

CMSHero.defaultProps = {
  backgroundImageLink: null,
  heroTeaser: {
    isEditorial: false,
    bigHeadline: '',
  },
  disableGatsbyImage: false,
  items: [],
};

export default CMSHero;
